/**
 * Marks history entries whose scroll position must not be restored.
 *
 * A page left through the next-listing turn was left at the scroll clamp,
 * looking at the next page's own opening grown to full size. Restoring that
 * position on Back shows the reader a full-size picture of the page they
 * just came back from — Back should read as "back to that page", which is
 * its top.
 *
 * The turn marks the entry it departs; `restorationKey` then answers with a
 * different key for marked entries, so the first return finds no saved
 * position and ScrollRestoration falls back to the top. The entry keeps the
 * marked key from there on, so everything after that first return saves and
 * restores as normal.
 */

const PREFIX = 'restore-at-top:';

export const markRestoreAtTop = (locationKey: string) => {
    try {
        sessionStorage.setItem(PREFIX + locationKey, '1');
    } catch {
        // Storage full or blocked: Back restores the clamp, which is the
        // behaviour this improves on, not something to break navigation for.
    }
};

export const restorationKey = (location: { key: string }): string => {
    try {
        return sessionStorage.getItem(PREFIX + location.key)
            ? `${location.key}:top`
            : location.key;
    } catch {
        return location.key;
    }
};
